import { call } from '@redux-saga/core/effects';
import type { PhysicalDocksBulkDeleteResult } from 'contracts/PhysicalDocks';
import { api, apiErrorHandler, notify } from 'services';
import type { BulkDeletePhysicalDocksDeleteAction } from 'store/ducks/physicalDocks';

export function* deletePhysicalDocksBulkRequest(action: any) {
  const { payload, onSuccess, onFailure }: BulkDeletePhysicalDocksDeleteAction =
    action;
  try {
    const { data }: { data: PhysicalDocksBulkDeleteResult } = yield call(
      api.delete,
      'docks-physical/bulk',
      { data: payload }
    );
    notify(
      'success',
      data.deletedCount === 1
        ? '1 doca física excluída com sucesso'
        : `${data.deletedCount} docas físicas excluídas com sucesso`
    );
    onSuccess?.(data);
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    notify('error', errorMessage);
    onFailure?.();
  }
}
